import { render } from "./_PanelResidentStatement.vue?vue&type=template&id=476eff89"
import script from "./_PanelResidentStatement.vue?vue&type=script&lang=js"
export * from "./_PanelResidentStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__